module.exports = __webpack_public_path__ + "static/media/ImagePlaceholder.3c0d83e9.svg";